import { collapsibleAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const collapsibleSlotRecipe = defineSlotRecipe({
  className: 'collapsible',
  slots: [...collapsibleAnatomy.keys()],
  base: {
    root: {
      width: '100%',
      textStyle: 'body/lg/regular',
    },
    content: {
      overflow: 'hidden',
      position: 'relative',
      _open: {
        animationName: 'expand-height',
        animationDuration: 'moderate',
      },
      _closed: {
        animationName: 'collapse-height',
        animationDuration: 'moderate',
        _after: {
          content: '""',
          position: 'absolute',
          insetInlineStart: 0,
          insetInlineEnd: 0,
          bottom: 0,
          height: '32',
          background: 'linear-gradient(to top, {colors.neutral.100}, transparent)',
          pointerEvents: 'none',
        },
      },
    },
    trigger: {
      display: 'flex',
      alignItems: 'center',
      color: 'text/link',
      cursor: 'pointer',
      gap: '4',
      textStyle: 'body/md/regular',
      paddingBlockStart: '8',
      width: 'fit-content',
      _hover: {
        color: 'text/link-hover',
        _active: {
          color: 'text/primary',
        },
      },
      _active: {
        color: 'text/primary',
      },
    },
    indicator: {},
  },
});

export default collapsibleSlotRecipe;
